const question1 = {
    'question': 'Czym zajmuje się psychogeriatra?',
    'answer': 'Psychogeriatra to lekarz, który specjalizuje się w chorobach psychicznych osób starszych. Leczy i diagnozuje zaburzenia psychiczne, takie jak: choroba Alzheimera, choroba Parkinsona, depresja i zaburzenia dwubiegunowe, zaburzenie lękowe, schizofrenia i zaburzenia urojeniowe. Psychogeriatra może również leczyć inne choroby psychiczne, które mogą wystąpić u osób starszych, takie jak zaburzenia snu, zaburzenia odżywiania i uzależnienia.',
}

export default question1;